"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _default = function _default() {
  return {
    name: 'get',
    synopsis: 'get [ITEM] ...[ITEMS]',
    description: 'Retrieve data at a position from a list',
    options: {
      i: {
        alias: 'index',
        description: 'index',
        type: 'number',
        required: true,
        valid: function valid(value, args) {
          return value > 0 && value < args.length;
        }
      }
    },
    execute: function execute(args, _ref) {
      var index = _ref.index;
      return args[index];
    }
  };
};

exports.default = _default;